import { render, staticRenderFns } from "./basicinfo.vue?vue&type=template&id=5d7f730f"
import script from "./basicinfo.vue?vue&type=script&lang=js"
export * from "./basicinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports